import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class Description extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-description">
                    <div className="fondrt-description__title">Описание проекта</div>
                    <div className="fondrt-description__text">
                        В сентябре 2022 года команда агентства «Вебпрактик» начала работу по
                        развитию сайта Фонда развития территорий фpт.рф. Это системно значимый и
                        важный сервис для дольщиков, через который до конца 2023 г. более 80 тыс.
                        семей должны получить квартиры. Для такого важного и динамичного проекта
                        нужны быстрые и современные ИТ-решения.
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Description;
